import { useEffect, useState } from 'react';

import styles from './Geolocation.module.css'
import { arrowIcon, geolocationIcon } from "../../assets/icons/icons.ts";
import { Button } from "../../ui/General/Button/Button.tsx";
import { ChooseCityModal } from "./Components/ChooseCityModal/ChooseCityModal.tsx";
// import {useLocalStorage} from "../../hooks/useLocalStorage.ts";
import { changeCurrentTown } from "@/utils/changeLocation.ts";
// import { useMultiStorage } from '../../hooks/useStorage.ts';
import { API_URL } from '../../config.tsx';
import { RootState, useAppDispatch, useAppSelector } from '@/utils/storage/stores/store.ts';
import { userInfoLoader } from '@/utils/storage/extra/loaders/user/userInfoLoader.ts';
import { cartOfferLoader } from '@/utils/storage/extra/loaders/cart/cartOfferLoader.ts';
import { setUserInfoField } from '@/utils/storage/slices/userSlice.ts';

export const Geolocation: React.FC = () => {
    const dispatch = useAppDispatch();
    // const  {getStorageValue} = useLocalStorage();
    // const townId = getStorageValue('currentTownId');
    // const townName = getStorageValue('currentTownName');
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId);
    const userInfo = useAppSelector((state: RootState) => state.user.userInfo);
    const { townId, townName } = userInfo || { townId: 1, townName: 'Владивосток' };
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const url = new URL(window?.location.href || '');
    const [notificationShown, setNotificationShown] = useState(!userInfo?.townId && url.pathname.indexOf('/m/') === -1);
    const [townIdByIp, setTownIdByIp] = useState(townId || 1);
    // const [storage, setStorage] = useMultiStorage({
    //     townId: ['townId', getStorageValue('townId')],
    //     getUserData: ['getUserData', false],
    //     getCartOffer: ['getCartOffer', false],
    // });

    const changeTown = (townId: number) => {
        changeCurrentTown(townId);
        setTimeout(function () {
            //     setStorage('townId', townId);
            //     setStorage('getUserData', true);
            //     setStorage('getCartOffer', true);
            dispatch(setUserInfoField({ name: 'townId', value: townId }));
            dispatch(userInfoLoader());
            dispatch(cartOfferLoader({ cartId: cartId || 0, isMini: false, all: true }));
            close();
        }, 1000);
        setNotificationShown(false);
        setIsOpen(false);
    };

    const getTownByIp = () => {
        fetch(`${API_URL}/find_town_by_ip`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => {
                if (data.name) {
                    setTownIdByIp(data.id);
                }
            })
    };

    useEffect(() => {
        if (Number(townId) === 0) getTownByIp();
        setNotificationShown(!userInfo?.townId && url.pathname.indexOf('/m/') === -1);
        //window.addEventListener('storage', () => {});
    }, [townId]);

    return (
        <div className={styles.wrapper}>
            <ChooseCityModal isOpen={isOpen} close={() => setIsOpen(false)} />
            {notificationShown && (
                <div className={styles.notification}>
                    <div className={styles.notificationHeader}>
                        <img width={15} height={15} src={arrowIcon} alt='Город' />
                        <div>
                            <div>Ваш город</div>
                            <div className={styles.notificationCity}>г. {townName}</div>
                        </div>
                    </div>
                    <div className={styles.notificationButtons}>
                        <Button type='regular' className={styles.notificationButton} onClick={() => changeTown(townIdByIp)}>Все верно</Button>
                        <Button type='text' className={styles.notificationText} onClick={() => { setNotificationShown(false); setIsOpen(true); }}>Выбрать другой</Button>
                    </div>
                </div>
            )}
            <a className={styles.geolocation} onClick={() => setIsOpen(true)}>
                <img src={geolocationIcon} alt='Геолокация' />
                г. {townName}
            </a>
        </div>
    );
};
